const uwmEntries = {
    EXPERIENCE_COACH_MERCURY: 'EXPERIENCE_COACH_MERCURY',
    EXPERIENCE_COACH_ORION: 'EXPERIENCE_COACH_ORION',
    DIAGNOSTIC_MERCURY: 'DIAGNOSTIC_MERCURY',
    USAGE_MERCURY: 'USAGE_MERCURY',
    LOCATION: 'LOCATION',
    INSIGHTS_ORION: 'INSIGHTS_ORION',
    FEEDBACK_ORION: 'FEEDBACK_ORION',
};

const uwmFeedbackEntries = {
    EXPERIENCE_COACH_MERCURY: 'ECM_FEEDBACK',
    EXPERIENCE_COACH_ORION: 'ECO_FEEDBACK',
    ONBOARDING: 'ONBOARDING_FEEDBACK',
    ADVANCED_DIAGNOSTIC: 'AD_FEEDBACK',
    USAGE: 'USAGE_FEEDBACK',
};

const ecUwmModuleSelfNames = ['ORION_INSIGHTS_A', 'ORION_INSIGHTS_B', 'ORION_FEEDBACK'];

export {ecUwmModuleSelfNames, uwmEntries, uwmFeedbackEntries};
